import React, { useState } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cookie_preferences'));
  const [customise, setCustomise] = useState(false);
  const [preferences, setPreferences] = useState({ essential: true, analytics: false, marketing: false });

  const save = (next = preferences) => {
    localStorage.setItem('cookie_preferences', JSON.stringify(next));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className="cookie" aria-label="Cookie preferences">
      <strong>Your privacy choices</strong>
      <p>We use essential cookies to operate the service. Optional analytics and marketing cookies require your consent.</p>
      {customise && (
        <div className="cookie-options">
          {Object.entries(preferences).map(([key, value]) => (
            <label key={key}>
              <input
                type="checkbox"
                checked={value}
                disabled={key === 'essential'}
                onChange={(event) => setPreferences({ ...preferences, [key]: event.target.checked })}
              />
              {key}
            </label>
          ))}
        </div>
      )}
      <div className="cookie-actions">
        <button className="button secondary small" onClick={() => setCustomise(!customise)}>Manage</button>
        <button className="button secondary small" onClick={() => save({ essential: true, analytics: false, marketing: false })}>Essential only</button>
        <button className="button small" onClick={() => save({ essential: true, analytics: true, marketing: true })}>Accept all</button>
      </div>
    </aside>
  );
}